import { ArrowRight } from 'lucide-react';

import { SectionWrapper } from '../../components/SectionWrapper';
import { proofStats } from './kaiCoachContent';

import styles from './KaiCoachProofSection.module.css';

export function KaiCoachProofSection() {
  return (
    <SectionWrapper
      aria-labelledby="kai-coach-proof-title"
      background="white"
      className={styles.root}
      data-testid="kai-coach-section-proof"
    >
      <div className={styles.head}>
        <h2 className={styles.title} id="kai-coach-proof-title">
          First course pilot · History 2C at UCLA, 2025 vs 2026
        </h2>
        {/* A plain anchor: the browser scrolls to the method note itself. */}
        <a className={styles.link} href="#method">
          How we measured
          <ArrowRight aria-hidden="true" size={16} />
        </a>
      </div>
      <ul className={styles.stats}>
        {proofStats.map((stat) => (
          <li className={styles.stat} key={stat.value}>
            <span className={styles.value}>{stat.value}</span>
            <span className={styles.label}>
              <strong>{stat.label}</strong>, {stat.detail}
            </span>
          </li>
        ))}
      </ul>
    </SectionWrapper>
  );
}
